import React, { useState } from 'react';

import {
  AlineButton,
  NameDialog,
  NameDialogVariant,
  useGetContractTypeSchema,
} from 'src/components';
import { useAccessGuard } from 'src/components/auth';
import { WhitePlusIcon } from 'src/components/icons/WhitePlusIcon';
import { Apollo } from 'src/gql/generated';
import { useDispatchSuccessSnack } from 'src/helpers';
import { useCreateContractTypes } from 'src/hooks';

export function NewContractTypeButton(): JSX.Element | null {
  const contractTypeSchema = useGetContractTypeSchema();
  const { createContractTypes, loading } = useCreateContractTypes();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const dispatchTypeCreatedSnack = useDispatchSuccessSnack({
    message: 'Contract type successfully created.',
  });
  const handleOpen = useAccessGuard({
    callback: () => setDialogOpen(!dialogOpen),
    minRole: Apollo.OrgRole.Admin,
  });

  async function handleSubmit(value: string): Promise<void> {
    const { data } = await createContractTypes({
      variables: {
        input: [{ value }],
      },
    });
    if (data) dispatchTypeCreatedSnack();

    setDialogOpen(false);
  }

  return (
    <>
      <AlineButton
        color="primary"
        endIcon={<WhitePlusIcon />}
        loading={loading}
        variant="contained"
        onClick={handleOpen}
      >
        New Contract Type
      </AlineButton>
      <NameDialog
        handleClose={() => setDialogOpen(false)}
        open={dialogOpen}
        placeholder="Enter contract type..."
        validationSchema={contractTypeSchema}
        variant={NameDialogVariant.ContractType}
        onFormikSubmit={handleSubmit}
      />
    </>
  );
}
